import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { ColorGradient } from '@progress/kendo-react-inputs';

type Props = {
  colors: string[];
  selectedColor: string;
  onSelectColor: (color: string) => void;
};

const getFromRgb = (rgb: string) => {
  const match = rgb.match(/\d+/g);
  if (!match) return '000000';
  return `${match
    .slice(0, 3)
    .map((x) => parseInt(x).toString(16).padStart(2, '0'))
    .join('')}`;
};

const ColorPalette: React.FC<Props> = ({
  colors,
  selectedColor,
  onSelectColor
}) => {
  const [showGradient, setShowGradient] = useState(false);
  const gradientContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        gradientContainerRef.current &&
        !gradientContainerRef.current.contains(event.target as Node)
      ) {
        setShowGradient(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelectColorFromGradient = (color: string) => {
    onSelectColor(color);
  };

  const handleCustomColorClick = () => {
    setShowGradient(true);
  };

  return (
    <Box marginTop={'15px'}>
      <Box display="grid" gridTemplateColumns="repeat(8, 1fr)" gap={1}>
        {colors.map((color) => (
          <Box
            key={color}
            width={36}
            height={36}
            borderRadius="50%"
            bgcolor={`#${color}`}
            display="flex"
            alignItems="center"
            justifyContent="center"
            onClick={() => onSelectColor(color)}
            sx={{ cursor: 'pointer', position: 'relative' }}
          >
            {selectedColor === color && (
              <i
                className="fa-solid fa-check"
                style={{ color: 'white', fontSize: '14px' }}
              ></i>
            )}
          </Box>
        ))}
      </Box>
      <div
        className="color-palette-custom-container"
        ref={gradientContainerRef}
      >
        <Typography
          className="input-field color-palette-custom-label"
          onClick={handleCustomColorClick}
        >
          Choose Custom Color
        </Typography>

        {showGradient && (
          <ColorGradient
            format="hex"
            opacity={false}
            defaultValue={`#${selectedColor}`}
            value={`#${selectedColor}`}
            onChange={(event) => {
              const hexColor = getFromRgb(event.value);
              handleSelectColorFromGradient(hexColor);
            }}
            style={{ marginTop: '10px' }}
          />
        )}
      </div>
    </Box>
  );
};

export default ColorPalette;
